import { useState } from "react";
import { motion } from "framer-motion";
import InspectionModal from "../mechanical/InspectionModal";

const WhoWeAreSection = () => {
  const [showModal, setShowModal] = useState(false);
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }
    }
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }
    }
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }
    }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };

  const statCardVariant = {
    hidden: { opacity: 0, x: 30, scale: 0.95 },
    visible: { 
      opacity: 1, 
      x: 0, 
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };

  const numberVariant = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { 
        duration: 0.6, 
        delay: 0.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
   <section className="bg-[#1A1A1A] text-white py-10 px-4 sm:px-6 overflow-x-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
        {/* LEFT CONTENT */}
        <motion.div 
          variants={fadeInLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }} // Trigger when 30% of element is visible
          className="lg:col-span-2"
        >
         

          <motion.h2 
            variants={fadeInUp}
            className="text-3xl md:text-4xl font-semibold leading-tight mb-6"
          >
            Boutique Automotive Services
          </motion.h2>

          <motion.p 
            variants={fadeInUp}
            className="text-yellow-400 font-medium mb-6"
          >
            Blending Your Idea On The Road.
          </motion.p>

          <motion.div 
            variants={staggerContainer}
            className="space-y-5 text-gray-300 text-sm leading-relaxed max-w-2xl"
          >
            {[
              "We started out early 2012 as a basic aftermarket service centre catering to nearly any vehicle we could get out hands on, slowly growing into a dream of being able to one day work on luxury cars and performance upgrades.",
              "Didn’t take too long! Good people really are the key to our success story, smart decisions and understanding customers supporting us have been the difference for our survival and growth plan.",
              "Today our facilities are no strangers to the likes of RR, Bentley’s and Ferrari’s whilst retaining our core values that any car is welcome. We are dealers for some of the best performance companies in the world (more about this on our performance page) and have carved out a niche business offering retro mods and restoration projects for those looking to breath fresh life into their prized possessions and in some cases painting and restoring show cars for globally event.",
              "We continue to push the boundaries and invest in new technology, latest of which is our chemical dipping facility in India and salvage breaking unit in Worcestershire UK.",
              "The future is never certain, however we’re fortunate to have the right people and ideas. We are excited to continue our aggressive expansion offering our Indian clients a special experience and new forms of happiness.",
              "Team, AJP"
            ].map((text, index) => (
              <motion.p 
                key={index}
                variants={fadeInUp}
              >
                {text}
              </motion.p>
            ))}
          </motion.div>

          <motion.button
            variants={fadeInUp}
            whileHover={{ 
              scale: 1.05,
              backgroundColor: "#b91c1c",
            }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowModal(true)}
            className="mt-8 bg-red-600 hover:bg-red-700 transition-all px-6 py-3 text-sm font-semibold rounded"
          >
            Contact UIs 
          </motion.button>
        </motion.div>

        {/* RIGHT STATS */}
        <motion.div 
          variants={fadeInRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="space-y-6"
        >
 
          <motion.div 
            variants={statCardVariant}
            whileHover={{ 
              scale: 1.05,
              borderColor: "#fbbf24",
              transition: { duration: 0.2 }
            }}
            className="border border-yellow-500/40 p-6 rounded cursor-default transition-all"
          >
            <motion.h3 
              variants={numberVariant}
              className="text-2xl font-bold text-yellow-400"
            >
              14+ <span className="text-sm font-medium text-white">year</span>
            </motion.h3>
            <motion.p 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.4 }}
              viewport={{ once: true }}
              className="text-gray-300 text-sm mt-1"
            >
              Of Craft & Dedication
            </motion.p>
          </motion.div>

          {/* CARD 2 */}
          <motion.div 
            variants={statCardVariant}
            whileHover={{ 
              scale: 1.05,
              borderColor: "#fbbf24",
              transition: { duration: 0.2 }
            }}
            className="border border-yellow-500/40 p-6  cursor-default transition-all"
          >
            <motion.h3 
              variants={numberVariant}
              className="text-2xl font-bold text-yellow-400"
            >
              4785+ <span className="text-sm font-medium text-white">Vehicles</span>
            </motion.h3>
            <motion.p 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              viewport={{ once: true }}
              className="text-gray-300 text-sm mt-1"
            >
              Repaired & Maintained (2026)
            </motion.p>
          </motion.div>

          {/* CARD 3 */}
          <motion.div 
            variants={statCardVariant}
            whileHover={{ 
              scale: 1.05,
              borderColor: "#fbbf24",
              transition: { duration: 0.2 }
            }}
            className="border border-yellow-500/40 p-6 rounded cursor-default transition-all"
          >
            <motion.h3 
              variants={numberVariant}
              className="text-2xl font-bold text-yellow-400"
            >
              14+ <span className="text-sm font-medium text-white">Restoration</span>
            </motion.h3>
            <motion.p 
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              viewport={{ once: true }}
              className="text-gray-300 text-sm mt-1"
            >
             Classic & Modern Cars
            </motion.p>
          </motion.div>
        </motion.div>
      </div>
      {showModal && <InspectionModal title="Contact Us" onClose={() => setShowModal(false)} />}
    </section>
  )
}

export default WhoWeAreSection;